
<template>
  <div class="kay-data-table">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-12">
              <div class="card-header">
                <h4 class="card-title">贈送優惠券店家 - {{campaignGroup.name}}</h4>
              </div>

              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                    <el-col :xs="12" :md="3">
                      <router-link to="../../send-coupons" type="success">
                        <el-button type="warning" size="small">返回活動列表</el-button>
                      </router-link>
                    </el-col>
                  </div>

                </div>
                <hr>
                <div class="row">
                  <div class="col-md-12">
                    <h5>1. 基本設定</h5>
                  </div>
                  <div class="col-md-6">
                    <!-- <label>活動名稱</label>
                    <el-input
                      size="small"
                      v-model="campaignGroup.name"
                      placeholder="新戶首次線上消費100送折價券"
                    ></el-input> -->
                    <fg-input label="活動名稱"
                      required
                      placeholder="新戶首次線上消費100送折價券"
                      v-model="campaignGroup.name"
                      v-validate="modelValidations.name"
                      :error="getError('name')"
                      name="name">
                    </fg-input>

                  </div>
                  <div class="col-md-6">
                    <label>贈送期間 - 開始時間</label>
                    <fg-input>
                      <el-date-picker
                        type="datetime"
                        placeholder="Date Time Picker"
                        format="yyyy-MM-dd HH:mm:ss"
                        v-model="startTime"
                      ></el-date-picker>
                    </fg-input>
                    <label>贈送期間 - 結束時間</label>
                    <fg-input>
                      <el-date-picker
                        type="datetime"
                        placeholder="Date Time Picker"
                        format="yyyy-MM-dd HH:mm:ss"
                        v-model="endTime"
                      ></el-date-picker>
                    </fg-input>
                  </div>
                  <div class="col-md-12">
                    <div class="text-center" v-if="mode === 'update'">
                      <div>
                        <el-button type="primary" size="mini" @click.native="saveInfo()">更新基本資訊</el-button>
                      </div>

                      <div v-if="updateInfo === 'updating'" style="margin: 10px 0 0 0;">
                        設定中
                        <i class="el-icon-loading"></i>
                      </div>
                      <div
                        v-if="updateInfo === 'success'"
                        style="color:#00BA00; margin: 10px 0 0 0;"
                      >
                        設定成功
                        <i class="now-ui-icons ui-1_check"></i>
                      </div>
                      <div v-if="updateInfo === 'error'" style="color:#BA0000; margin: 10px 0 0 0;">
                        設定失敗
                        <i class="now-ui-icons ui-1_simple-remove"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-header">
                <h5 class="card-title">2. 贈送條件（符合條件者，下單後可獲得優惠券）</h5>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <div class="row k-form-group">
                      <label class="col-sm-2 col-form-label k-form-label">必須是新戶</label>
                      <div class="col-sm-10 checkbox-radios">
                        <radio label="Y" v-model="conditions.shopNewCheck">是</radio>
                        <radio label="N" v-model="conditions.shopNewCheck">不限制</radio>
                        <!-- <radio label="2" v-model="campaignGroup.name">Second Radio</radio> -->
                      </div>
                    </div>
                    <div class="row k-form-group">
                      <label class="col-sm-2 col-form-label k-form-label">限定支付方式</label>
                      <div class="col-sm-10 checkbox-radios">
                        <radio label="Q" v-model="conditions.paymentCheck">線上支付才贈送</radio>
                        <radio label="N" v-model="conditions.paymentCheck">不限制</radio>
                        <!-- <radio label="2" v-model="campaignGroup.name">Second Radio</radio> -->
                      </div>
                    </div>
                    <div class="row k-form-group">
                      <label class="col-sm-2 col-form-label k-form-label">消費門檻</label>

                      <div class="col-sm-10 checkbox-radios">
                        <div class="row">
                          <div class="col-md-6">
                            <radio label="Y" v-model="conditions.amountCheck">消費須達指定金額</radio>
                          </div>
                        </div>
                        <radio label="N" v-model="conditions.amountCheck">不限制</radio>
                      </div>

                      <label
                        v-if="conditions.amountCheck == 'Y'"
                        class="col-sm-2 col-form-label"
                      >低消金額(元)：</label>
                      <div v-if="conditions.amountCheck == 'Y'" class="col-sm-3 k-input">
                        <el-input placeholder="50" size="small" v-model="conditions.minConsumption"></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <b>贈送規則：</b>
                    <p>1. 顧客完成訂單的當下，符合條件者會推送優惠碼給顧客</p>
                    <p>2. 一個贈送優惠券活動，每為顧客只能獲得一次</p>
                  </div>
                  <div class="col-md-12">
                    <div class="text-center" v-if="mode === 'update'">
                      <div>
                        <el-button
                          type="primary"
                          size="mini"
                          @click.native="saveConditions()"
                        >更新贈送條件</el-button>
                      </div>

                      <div v-if="updateConditions === 'updating'" style="margin: 10px 0 0 0;">
                        設定中
                        <i class="el-icon-loading"></i>
                      </div>
                      <div
                        v-if="updateConditions === 'success'"
                        style="color:#00BA00; margin: 10px 0 0 0;"
                      >
                        設定成功
                        <i class="now-ui-icons ui-1_check"></i>
                      </div>
                      <div
                        v-if="updateConditions === 'error'"
                        style="color:#BA0000; margin: 10px 0 0 0;"
                      >
                        設定失敗
                        <i class="now-ui-icons ui-1_simple-remove"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card-header">
                <h5 class="card-title">3. 活動訊息設定</h5>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <label>贈送訊息</label>
                    <el-input required type="textarea" :rows="5" v-model="campaignGroup.voucherMessage" ></el-input>
                    <label>額滿訊息</label>
                    <el-input required type="textarea" :rows="5" v-model="campaignGroup.fullQuotaMessage"></el-input>
                  </div>
                  <div class="col-md-6">
                    <p>可用變數：</p>
                    <ul>
                      <li v-pre>{{order.name}}: 訂單訂購人姓名</li>
                      <li v-pre>{{code.voucher}}: 匯入的優惠券代碼或連結</li>
                      <li v-pre>{{code.authCode}}: 匯入的優惠券密碼</li>
                    </ul>
                    <el-button type="success" size="mini" @click.native="useTemplate()" plain>套用範例</el-button>
                  </div>
                  <div class="col-md-12">
                    <div class="text-center" v-if="mode === 'update'">
                      <div>
                        <el-button type="primary" size="mini" @click.native="saveMessages()">更新活動訊息</el-button>
                      </div>

                      <div v-if="updateMessages === 'updating'" style="margin: 10px 0 0 0;">
                        設定中
                        <i class="el-icon-loading"></i>
                      </div>
                      <div
                        v-if="updateMessages === 'success'"
                        style="color:#00BA00; margin: 10px 0 0 0;"
                      >
                        設定成功
                        <i class="now-ui-icons ui-1_check"></i>
                      </div>
                      <div
                        v-if="updateMessages === 'error'"
                        style="color:#BA0000; margin: 10px 0 0 0;"
                      >
                        設定失敗
                        <i class="now-ui-icons ui-1_simple-remove"></i>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="text-center" v-if="mode === 'new'">
                  <div v-if="createMessage === 'updating'" style="margin: 10px 0 0 0;">
                    建立中
                    <i class="el-icon-loading"></i>
                  </div>
                  <div
                    v-if="createMessage === 'success'"
                    style="color:#00BA00; margin: 10px 0 0 0;"
                  >
                    建立成功
                    <i class="now-ui-icons ui-1_check"></i>
                  </div>
                  <div
                    v-if="createMessage === 'error'"
                    style="color:#BA0000; margin: 10px 0 0 0;"
                  >

                  <p v-for="item in createErrorMessages"><i class="now-ui-icons ui-1_simple-remove"></i> {{ item }}</p>

                  </div>
                  <el-button type="primary" @click.native="createCampaign()">建立活動</el-button>
                </div>

              </div>

              <!-- <div class="card-header">
                <h5 class="card-title">4. 新增參與店家</h5>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                    <el-row :gutter="20">
                      <el-col :xs="24" :md="6">
                        <el-input
                          v-model="filters[0].value"
                          size="small"
                          placeholder="搜尋活動"
                          prefix-icon="el-icon-search"
                        ></el-input>
                      </el-col>
                      <el-col :xs="24" :md="6">
                        <router-link to="./send-coupons/add-shops" type="success">
                          <el-button type="primary" size="small" plain>新增參與店家</el-button>
                        </router-link>
                      </el-col>
                    </el-row>

                    <data-tables :data="data" :filters="filters" :action-col="actionCol">
                      <el-table-column
                        v-for="title in titles"
                        :prop="title.prop"
                        :label="title.label"
                        :key="title.prop"
                        sortable="custom"
                      ></el-table-column>
                    </data-tables>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { Checkbox, Radio } from "src/components/index";
import {
  TimeSelect,
  DatePicker,
  Tag,
  Input,
  Button,
  Select,
  Option
} from "element-ui";

export default {
  components: {
    [DatePicker.name]: DatePicker,
    Checkbox,
    Radio
  },
  data() {
    return {
      modelValidations: {
        name: {
          required: true
        },
        // fullQuotaMessage: {
        //   required: true,
        //   // email: true
        // },
        // voucherMessage: {
        //   required: true,
        //   // min: 5
        // }
      },
      mode: 'new',
      createMessage: null,
      createErrorMessages: [],
      updateInfo: null,
      updateConditions: null,
      updateMessages: null,
      campaignGroup: {
        startTime: "",
        endTime: "",
        conditions: [],
        voucherMessage: "",
        fullQuotaMessage: ""
      },
      startTime: "",
      endTime: "",
      conditions: {
        shopNewCheck: "N", // Y: 新戶only, N: 不限制
        paymentCheck: "N", // Q: Qrpay, N:不限制
        amountCheck: "N", // Y: 有低消, N: 不限制
        minConsumption: "0" // 數字：最低消費, '0': 不限制
      }
    };
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    handleClick(command) {
      this.$message(`click dropdown button ${command}`);
    },
    formatCampaign() {
      let self = this;
      // 處理conditions
      for (let i = 0; i < self.campaignGroup.conditions.length; ++i) {
        switch (self.campaignGroup.conditions[i].name) {
          case "paymentCheck":
            self.conditions.paymentCheck = "Q";
            // this.campaignGroup.conditions[i] = {
            //   derivation: "{{IF(order.paymentTypes !== 'cash','Y','N')}}",
            //   eval: false
            // }
            break;
          case "shopNewCheck":
            self.conditions.shopNewCheck = "Y";
            break;
          case "amountCheck":
            self.conditions.amountCheck = "Y";
            self.conditions.minConsumption =
              self.campaignGroup.conditions[i].value || 0; // 另外拉出來做成參數比較好做
            break;
        }
      }
      // this.campaignGroup.conditions;
      this.startTime = moment.unix(self.campaignGroup.startTs).toISOString();
      // .format("YYYY-MM-DD HH:mm:ss Z");

      this.endTime = moment.unix(self.campaignGroup.endTs).toISOString();

      // .format("YYYY-MM-DD HH:mm:ss Z");
      return;
    },
    getCampaignDetail() {
      let self = this;
      return axios
        .get(
          `${process.env.VUE_APP_APIHOST}/si/voucher-campaigns/${this.$route.params.groupId}`
        )
        .then(response => {
          this.campaignGroup = response.data || {};

          console.log(
            "the campaign group " + JSON.stringify(self.campaignGroup)
          );
          this.formatCampaign();
          console.log("our conditions " + JSON.stringify(self.conditions));
          return response.data;
        });
    },
    createCampaign() {
      this.createMessage = 'updating';
      this.createErrorMessages = [];
      this.$validator.validateAll().then(isValid => {

        if (this.startTime)
          this.campaignGroup.startTs = moment(this.startTime).unix();

        if (this.endTime)
          this.campaignGroup.endTs = moment(this.endTime).unix();

        if (!this.campaignGroup.name) {
          this.createMessage = 'error';
          this.createErrorMessages.push('姓名必填');
        }

        if (!this.campaignGroup.startTs) {
          this.createMessage = 'error';
          this.createErrorMessages.push('開始時間必填');
        }

        if (!this.campaignGroup.endTs) {
          this.createMessage = 'error';
          this.createErrorMessages.push('結束時間必填');
        }

        if (!this.campaignGroup.voucherMessage.trim()) {
          this.createMessage = 'error';
          this.createErrorMessages.push('贈送訊息必填');
        }

        if (!this.campaignGroup.fullQuotaMessage.trim()) {
          this.createMessage = 'error';
          this.createErrorMessages.push('額滿訊息必填');
        }

        let conditions = this.handleSaveConditions();

        if (!conditions.length) {
          this.createMessage = 'error';
          this.createErrorMessages.push('條件設定有誤，請洽管理人員');
        }
        this.campaignGroup.conditions = conditions;

        console.log('any error? ' + this.createErrorMessages.length);
        if (this.createErrorMessages.length > 0) {
          return;
        }

        return axios
          .post(
            `${process.env.VUE_APP_APIHOST}/si/voucher-campaigns`,
            this.campaignGroup
          )
          .then(response => {
            this.createMessage = "success";

            // this.campaignGroup = response.data || {};
            // this.formatCampaign();
            this.$router.push(`../send-coupons`);

            // console.log(response.data);
            return response.data;
          })
          .catch(e => {
            console.log(e.stack);
            this.createMessage = "error";
            this.createErrorMessages.push(e.message);
          });
      });


    },
    saveInfo() {
      // console.log("the campaign group " + JSON.stringify(this.campaignGroup));
      this.updateInfo = "updating";
      this.campaignGroup.startTs = moment(this.startTime).unix();
      this.campaignGroup.endTs = moment(this.endTime).unix();

      return axios
        .put(
          `${process.env.VUE_APP_APIHOST}/si/voucher-campaigns/${this.$route.params.groupId}`,
          {
            name: this.campaignGroup.name,
            startTs: this.campaignGroup.startTs,
            endTs: this.campaignGroup.endTs
          }
        )
        .then(response => {
          this.updateInfo = "success";

          this.campaignGroup = response.data || {};
          this.formatCampaign();

          // console.log(response.data);
          return response.data;
        })
        .catch(e => {
          console.log(e.stack);
          this.updateInfo = "error";
        });
    },
    handleSaveConditions() {
      let conditions = [];
      let matching = "";
      let matchFirst = true;
      if (this.conditions.shopNewCheck === "Y") {
        conditions.push({
          name: "shopNewCheck",
          derivation: "{{IF(order.isShopNew === true, 'Y', 'N')}}",
          eval: false
        });
        if (!matchFirst) matching += " && ";
        matching += "compute.shopNewCheck == 'Y'";
        matchFirst = false;
      }

      if (this.conditions.paymentCheck == "Q") {
        conditions.push({
          name: "paymentCheck",
          derivation: "{{IF(order.paymentTypes !== 'cash','Y','N')}}",
          eval: false
        });

        if (!matchFirst) matching += " && ";
        matching += "compute.paymentCheck == 'Y'";
        matchFirst = false;
      }

      if (this.conditions.amountCheck == "Y") {
        conditions.push({
          name: "amountCheck",
          derivation: `{{IF(order.amount >= ${this.conditions.minConsumption ||
            0}, 'Y','N')}}`,
          value: this.conditions.minConsumption || 0,
          eval: false
        });
        if (!matchFirst) matching += " && ";
        matching += "compute.amountCheck == 'Y'";
        matchFirst = false;
      }

      let matchingDerivation = `Y`;
      if (matching.length > 0) {
        matchingDerivation = `{{IF(${matching}, 'Y', 'N')}}`;
      }

      conditions.push({
        name: "matching",
        derivation: matchingDerivation,
        eval: false
      });
      return conditions;
    },
    saveConditions() {
      this.updateConditions = "updating";
      let conditions = this.handleSaveConditions();
      // let conditions = [];
      // let matching = "";
      // let matchFirst = true;
      // if (this.conditions.shopNewCheck === "Y") {
      //   conditions.push({
      //     name: "shopNewCheck",
      //     derivation: "{{IF(order.isShopNew === true, 'Y', 'N')}}",
      //     eval: false
      //   });
      //   if (!matchFirst) matching += " && ";
      //   matching += "compute.shopNewCheck == 'Y'";
      //   matchFirst = false;
      // }

      // if (this.conditions.paymentCheck == "Q") {
      //   conditions.push({
      //     name: "paymentCheck",
      //     derivation: "{{IF(order.paymentTypes !== 'cash','Y','N')}}",
      //     eval: false
      //   });

      //   if (!matchFirst) matching += " && ";
      //   matching += "compute.shopNewCheck == 'Y'";
      //   matchFirst = false;
      // }

      // if (this.conditions.amountCheck == "Y") {
      //   conditions.push({
      //     name: "amountCheck",
      //     derivation: `{{IF(order.amount > ${this.conditions.minConsumption ||
      //       0}, 'Y','N')}}`,
      //     value: this.conditions.minConsumption || 0,
      //     eval: false
      //   });
      //   if (!matchFirst) matching += " && ";
      //   matching += "compute.amountCheck == 'Y'";
      //   matchFirst = false;
      // }

      // let matchingDerivation = `{{IF(${matching}, 'Y', 'N')}}`;
      // conditions.push({
      //   name: "matching",
      //   derivation: matchingDerivation,
      //   eval: false
      // });
      return axios
        .put(
          `${process.env.VUE_APP_APIHOST}/si/voucher-campaigns/${this.$route.params.groupId}/conditions`,
          {
            conditions: conditions
          }
        )
        .then(response => {
          this.updateConditions = "success";

          this.campaignGroup = response.data || {};
          this.formatCampaign();

          // console.log(response.data);
          return response.data;
        })
        .catch(e => {
          console.log(e.stack);
          this.updateConditions = "error";
        });
    },
    useTemplate() {
      this.campaignGroup.voucherMessage = "Hi {{order.name}}， 感謝你完成此筆訂單，優惠券送給你，點擊網址立即領取。{{code.voucher}}，密碼是 {{code.authCode}}";
      this.campaignGroup.fullQuotaMessage = "哎呀  Sorry~  限量100組LINE Points 15點已經發送完畢囉!快點加入 LINE@帳號 ,才不會錯過更多美食優惠活動! ";
    },
    saveMessages() {
      this.updateMessages = "updating";

      return axios
        .put(
          `${process.env.VUE_APP_APIHOST}/si/voucher-campaigns/${this.$route.params.groupId}/messages`,
          {
            voucherMessage: this.campaignGroup.voucherMessage,
            fullQuotaMessage: this.campaignGroup.fullQuotaMessage
          }
        )
        .then(response => {
          this.updateMessages = "success";

          this.campaignGroup = response.data || {};
          this.formatCampaign();

          console.log(response.data);
          return response.data;
        })
        .catch(e => {
          console.log(e.stack);
          this.updateMessages = "error";
        });
    }
  },
  created () {
    this.mode = 'new';
    if (this.$route.params.groupId) {
      this.getCampaignDetail();
      this.mode = 'update';
    }

    // this.getCampaignGroups();
  }
};
</script>
<style scoped>
.kay-data-table .btn-base,
.el-select .el-input .el-input__inner,
.btn,
.navbar .navbar-nav > a.btn {
  margin: 0px !important;
}
.k-form-label {
  margin: 5px 0 0 0;
}
.k-form-group {
  margin: 10px 0 10px 0;
}
/* .k-input input { */
/* margin: 10px; */
/* width: 100px; */
/* height: 30px; */
/* } */
</style>
